import { debounce } from 'lodash'
import { observable, computed, action } from 'mobx'
import moment from 'moment'

export default class StartDateState {
  stepId = 'StartDate'
  title = 'Do you want to schedule this job for later?'
  trackingId = 'Onboarding - Start Date'

  @observable
  dateStart = moment()

  constructor({ wizard }) {
    this.wizard = wizard
    this._postponeStartDate = debounce(this._postponeStartDate.bind(this), 300)
  }

  // TODO: Once all wizard steps are migrated fully to new grcp endpoints, this can be
  // removed and refactored in the ProjectWizardStore.js flow.
  get skipSyncJob() {
    return true
  }

  get minDate() {
    return moment().startOf('day')
  }

  @computed
  get nextEnabled() {
    return true
  }

  @computed
  get continueButtonText() {
    return 'Continue'
  }

  @computed
  get relevant() {
    const step = this.wizard.getStep('ProjectType')
    if (!step) {
      return false
    }

    return !!this.wizard.job.legend?.allowScheduling
  }

  @action
  setDate(value) {
    this.dateStart = value ? moment(value) : moment()

    if (!this.dateStart.isValid()) {
      this.dateStart = moment()
    }

    this._postponeStartDate()
  }

  async hydrate(job) {
    this.dateStart = job.dateStart ? moment(job.dateStart) : moment()
  }

  async _postponeStartDate() {
    await this.wizard.rootStore.draftStore.postponeStartDate(
      this.wizard.job.id,
      this.dateStart.toDate()
    )
  }
}
